/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FmlxToast} from "fmlx-common-ui";
import {updateHeaders} from "../../lib/AxiosConfig";
import {deleteCookie} from "../../lib/cookieHelper";
import {ConsoleLog} from "../../lib/ConsoleHelper";
// import { ALERT_VARIANT, PLACEMENT } from "../../const/dataEnum";
import {logout} from "../../stores/actions/appStateAction";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import {COOKIE_AUTHTOKEN} from "../../const/dataEnum";

const AlertLayout = ({children}) => {
  const dispatch = useDispatch();
  const {showAlert, messageAlert, typeAlert, alertPlace, delay} = useSelector((state) => ({
    // authtoken: state.appState.authtoken,
    // user: state.appState.user,
    // menu: state.appState.menu,
    showAlert: state.alertModalState.showAlert,
    messageAlert: state.alertModalState.messageAlert,
    typeAlert: state.alertModalState.typeAlert,
    alertPlace: state.alertModalState.alertPlace,
    delay: state.alertModalState.delay,
  }));

  useEffect(() => {
    if (showAlert && messageAlert === "Unauthorized") {
      Logout();
    }
  }, [showAlert]);
  useEffect(() => {
    ConsoleLog("Alert timeout", showAlert, delay);
    if (delay)
      setTimeout(function () {
        dispatch(
          setAlert({
            show: false,
            timeout: null,
          })
        );
      }, delay);
  }, [delay]);

  function Logout() {
    deleteCookie(COOKIE_AUTHTOKEN);
    dispatch(logout());
    dispatch(updateHeaders());
  }

  return (
    <React.Fragment>
      {showAlert && (
        <FmlxToast
          title={typeAlert[0].toUpperCase() + typeAlert.slice(1)}
          content={messageAlert}
          variant={typeAlert}
          open={showAlert}
          onClick={() => {
            dispatch(
              setAlert({
                show: false,
                variant: typeAlert,
                message: "",
                timeout: null,
              })
            );
          }}
          placement={alertPlace}
          useActionButton={false}
        />
      )}
      {children}
    </React.Fragment>
  );
};

export default AlertLayout;